import * as React from 'react';
import {AiOutlineMenu, AiFillHome} from 'react-icons/ai';
import {
  FaFileImport,
  FaFileInvoice,
  FaFileInvoiceDollar,
  FaHandshake,
  FaUserFriends
} from 'react-icons/fa';
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import { RiAdminFill } from 'react-icons/ri';
import { BsFileEarmarkBarGraphFill } from 'react-icons/bs';

import {useOnClickOutside, usePermissions} from '@Hooks';
import { useAuthStore } from '@Stores';

import SidebarItem from './SidebarItem';
import styles from './Sidebar.module.scss';
import Separator from "@Components/Separator/Separator";
import {LiaFileInvoiceDollarSolid} from "react-icons/lia";
import {BiSolidReport} from "react-icons/bi";
import {
    AppsCostImportPermissions,
    AppsInputPermissions,
    AppsOutflowPermissions
} from "../../../../AppConstants/Permissions";

type SidebarProps = {
    isOpen?: boolean;
    close: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ isOpen, close }) => {
    const appSecurityModel = useAuthStore(state => state.appSecurityModel);
    const { isHasPermissions } = usePermissions([AppsCostImportPermissions.readAppCostImport, AppsInputPermissions.readAppInput, AppsOutflowPermissions.readAppOutflow]);

    const sidebarRef = React.useRef(null);

    useOnClickOutside(sidebarRef, close);

  const [expandedGroups, setExpandedGroups] = React.useState<Record<string, boolean>>({
    general: true,
    admin: true,
  });

  const toggleGroup = (group: "accruals" | "invoicing" | "apps") => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };


  if (!isOpen || !appSecurityModel) return null;

    const canReadAdministration = appSecurityModel.hasPrincipalApplicationAdministrationRead || appSecurityModel.hasPrincipalAnyMetadataRead;
    return (
        <div ref={sidebarRef} className={styles.sidebar}>
            <SidebarItem
                title='Hide menu'
                className={styles.closeSidebarItem}
                Icon={AiOutlineMenu}
                onClick={close}
            />
            <SidebarItem
                text='Home'
                href='/'
                Icon={AiFillHome}
                onClick={close}
            />
          <SidebarItem
            text='Local Unit Agreements'
            href='/local-unit-agreement'
            Icon={FaHandshake}
            onClick={close}
          />
          <SidebarItem
            text='Service Beneficiary Agreements'
            href='/service-beneficiary-agreement'
            Icon={FaHandshake}
            onClick={close}
          />
          <Separator />
            <>
              <div className={styles.groupHeader} onClick={() => toggleGroup("accruals")}>
                {expandedGroups.accruals ? <FiChevronDown /> : <FiChevronRight />}
                <h4 className={styles.groupTitle}>Accruals</h4>
              </div>
              {expandedGroups.accruals && (
                <div className={styles.groupContent}>
                  <SidebarItem
                    text='Accruals Inflow'
                    href='/accruals-inflow'
                    Icon={BsFileEarmarkBarGraphFill}
                    onClick={close}
                  />
                  <SidebarItem
                    text='Accruals Outflow'
                    href='/accruals-outflow'
                    Icon={BsFileEarmarkBarGraphFill}
                    onClick={close}
                  />
                </div>
              )}
            </>
          <Separator />
          <SidebarItem
            text='Reports'
            href='/reports'
            Icon={BiSolidReport}
            onClick={close}
          />
          <Separator />
          <>
            <div className={styles.groupHeader} onClick={() => toggleGroup("invoicing")}>
              {expandedGroups.invoicing ? <FiChevronDown /> : <FiChevronRight />}
              <h4 className={styles.groupTitle}>Invoicing</h4>
            </div>
            {expandedGroups.invoicing && (
              <div className={styles.groupContent}>
                <SidebarItem
                  text='Invoicing Inflow'
                  href='/invoicing-inflow'
                  Icon={LiaFileInvoiceDollarSolid}
                  onClick={close}
                />
                <SidebarItem
                  text='Invoicing Outflow'
                  href='/invoicing-outflow'
                  Icon={LiaFileInvoiceDollarSolid}
                  onClick={close}
                />
              </div>
            )}
          </>
          <Separator />
          <>
            <div className={styles.groupHeader} onClick={() => toggleGroup("apps")}>
              {expandedGroups.apps ? <FiChevronDown /> : <FiChevronRight />}
              <h4 className={styles.groupTitle}>APPs</h4>
            </div>
          {expandedGroups.apps && (
            <div className={styles.groupContent}>
              { isHasPermissions[AppsCostImportPermissions.readAppCostImport] && <SidebarItem
                text='Cost Import'
                href='/cost-import'
                Icon={FaFileImport}
                className={styles.iconSize}
                onClick={close}
              />
              }
              { isHasPermissions[AppsInputPermissions.readAppInput] && <SidebarItem
                text='Inflow'
                href='/inflow'
                Icon={FaFileInvoiceDollar}
                className={styles.iconSize}
                onClick={close}
              />
                }
              { isHasPermissions[AppsOutflowPermissions.readAppOutflow] &&
              <SidebarItem
                text='Ouflow'
                href='/outflow'
                Icon={FaFileInvoice}
                className={styles.iconSize}
                onClick={close}
              />
              }
            </div>
          )}
          </>
          <Separator />
          <SidebarItem
            text='People Verification'
            href='/people-verification'
            Icon={FaUserFriends}
            onClick={close}
          />
          <Separator />
            {canReadAdministration &&
                <SidebarItem
                    text='Administration'
                    href='/administration'
                    Icon={RiAdminFill}
                    onClick={close}
                />
            }
        </div>
    );
};

export default Sidebar;